import { render, staticRenderFns } from "./CollectionPointRegisterModal.vue?vue&type=template&id=e876a28a&scoped=true"
import script from "./CollectionPointRegisterModal.vue?vue&type=script&lang=js"
export * from "./CollectionPointRegisterModal.vue?vue&type=script&lang=js"
import style0 from "./CollectionPointRegisterModal.vue?vue&type=style&index=0&id=e876a28a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e876a28a",
  null
  
)

export default component.exports